(function() {
  'use strict';
  
  // Configuration
  const EXIT_URL = 'https://www.google.com';
  const CUSTOMER_EMAIL = '';
  const KLAVIYO_FORM_ID = '';
  
  // Klaviyo queue management
  let klaviyoQueue = [];
  let klaviyoReady = false;
  
  function checkKlaviyoReady() {
    if (typeof window._learnq !== 'undefined') {
      klaviyoReady = true;
      // Flush queued events
      klaviyoQueue.forEach(event => {
        window._learnq.push(event);
      });
      klaviyoQueue = [];
      return true;
    }
    return false;
  }
  
  function trackKlaviyoEvent(eventData) {
    if (klaviyoReady || checkKlaviyoReady()) {
      window._learnq.push(eventData);
    } else {
      klaviyoQueue.push(eventData);
      // Keep checking for Klaviyo
      setTimeout(checkKlaviyoReady, 100);
    }
  }
  
  // Check URL params for force flag or existing verification
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      forceAgeGate: params.has('forceAgeGate'),
      state: params.get('state'),
      ageVerified: params.get('age_verified') === 'true'
    };
  }
  
  // Check if user is already verified
  function isUserVerified() {
    const urlParams = getUrlParams();
    
    // Force display if param is present
    if (urlParams.forceAgeGate) {
      return false;
    }
    
    // Check URL params
    if (urlParams.ageVerified && urlParams.state) {
      return true;
    }
    
    // Check sessionStorage
    try {
      const storedData = sessionStorage.getItem('cbdUserData');
      if (storedData) {
        const data = JSON.parse(storedData);
        if (data.age_verified && data.state) {
          // Restore to window object
          window.cbdUserData = data;
          return true;
        }
      }
    } catch (e) {
      console.warn('Error checking sessionStorage:', e);
    }
    
    return false;
  }
  
  // Update URL with state and verification
  function updateURL(state) {
    const url = new URL(window.location);
    url.searchParams.set('state', state);
    url.searchParams.set('age_verified', 'true');
    url.searchParams.delete('forceAgeGate');
    window.history.replaceState({}, '', url);
  }
  
  // Store verification data
  function storeVerificationData(state) {
    const timestamp = new Date().toISOString();
    const data = {
      state: state,
      age_verified: true,
      timestamp: timestamp,
      state_collection_date: timestamp
    };
    
    // Store in sessionStorage
    try {
      sessionStorage.setItem('cbdUserData', JSON.stringify(data));
    } catch (e) {
      console.warn('Could not save to sessionStorage:', e);
    }
    
    // Store globally
    window.cbdUserData = data;
    
    // Dispatch custom event
    window.dispatchEvent(new CustomEvent('cbdUserVerified', { 
      detail: data 
    }));
    
    return data;
  }
  
  // Main initialization
  function initAgeVerification() {
    const wrapper = document.getElementById('cbd-age-gate-overlay')
    if (!wrapper) return;
    
    // Check if already verified
    if (isUserVerified()) {
      wrapper.setAttribute('data-hidden', 'true');
      wrapper.style.display = 'none';  // ← ADDED THIS LINE
      return;
    }
    
    // Show the popup
    wrapper.setAttribute('data-hidden', 'false');
    wrapper.style.display = 'flex';  // ← ADDED THIS LINE
    document.body.style.overflow = 'hidden';  // ← ADDED THIS LINE
    document.body.style.position = 'fixed';   // ← ADDED THIS LINE
    document.body.style.width = '100%';       // ← ADDED THIS LINE
    
    const stateSelect = document.getElementById('user_state');
    const enterBtn = document.getElementById('button__enter');
    const exitBtn = document.getElementById('button__exit');
    const loading = document.getElementById('verification-loading');
    
    if (!stateSelect || !enterBtn || !exitBtn) {
      console.error('Age verification elements not found');
      return;
    }
    
    // Enable/disable enter button based on state selection
    stateSelect.addEventListener('change', function() {
      enterBtn.disabled = !this.value;
    });
    
    // Handle exit button
    exitBtn.addEventListener('click', function() {
      window.location.href = EXIT_URL;
    });
    
    // Handle enter button
    enterBtn.addEventListener('click', function() {
      const selectedState = stateSelect.value;
      
      if (!selectedState) {
        alert('Please select your state');
        return;
      }
      
      // Show loading
      loading.style.display = 'block';
      enterBtn.disabled = true;
      
      // Store verification data
      const verificationData = storeVerificationData(selectedState);
      fetch('/cart/update.js', {
  method: 'POST',
  headers: {'Content-Type': 'application/json'},
  body: JSON.stringify({
    attributes: {
      'customer_state': selectedState,
      'age_verified': 'true'
    }
  })
});
      
      // Track in Klaviyo
      const klaviyoEvent = ["track", "Age Verification Completed", {
        customer_state: selectedState,
        age_verified_21: true,
        state_collection_date: verificationData.timestamp
      }];
      
      trackKlaviyoEvent(klaviyoEvent);
      
      // If customer email exists, also identify
      if (CUSTOMER_EMAIL) {
        const identifyEvent = ["identify", {
          $email: CUSTOMER_EMAIL,
          customer_state: selectedState,
          age_verified_21: true,
          state_collection_date: verificationData.timestamp
        }];
        trackKlaviyoEvent(identifyEvent);
      }
      
      // Update URL
      updateURL(selectedState);

      // Update header immediately
      var desktop = document.getElementById('custom-selected-state');
      var mobile = document.getElementById('custom-selected-state-mobile');
      if(desktop) desktop.textContent = 'Deliver to ' + selectedState;
      if(mobile) mobile.textContent = 'Deliver to ' + selectedState;
      
      // Hide popup after short delay
      setTimeout(function() {
        wrapper.setAttribute('data-hidden', 'true');
        wrapper.style.display = 'none';  // ← ADDED THIS LINE
        document.body.style.overflow = '';    // ← ADDED THIS LINE
        document.body.style.position = '';    // ← ADDED THIS LINE
        document.body.style.width = '';       // ← ADDED THIS LINE
        loading.style.display = 'none';
      }, 500);
    });
    
    // Initialize Klaviyo check
    checkKlaviyoReady();
    if (!klaviyoReady) {
      // Keep checking every 100ms for up to 5 seconds
      let checkCount = 0;
      const checkInterval = setInterval(function() {
        if (checkKlaviyoReady() || checkCount++ > 50) {
          clearInterval(checkInterval);
        }
      }, 100);
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeVerification);
  } else {
    initAgeVerification();
  }
})();